import { Typography } from '@mui/material'
import { PageItemAddressDetailsEnum, PageItemDetails } from '../../RestockingTypes'
import { TableItemAddressesDetails } from '../TableItemAddressesDetails/TableItemAddressesDetails'
import * as S from './CardItemDetails.styles'

interface Props {
  pageItemDetails: PageItemDetails
}

export const CardItemDetails = ({ pageItemDetails }: Props) => {
  const getTitle = (type: string) => {
    switch (type) {
      case PageItemAddressDetailsEnum.COLLECT:
        return 'COLETA'
      case PageItemAddressDetailsEnum.RESTOCK:
        return 'REPOSIÇÃO'
      default:
        return ''
    }
  }

  return (
    <S.CardItem>
      <Typography variant='h6' fontWeight='bold' sx={{ alignSelf: 'center' }}>Detalhes do Item</Typography>
      <S.GridProductInfo>
        <S.CustomTextField
          name='productCode'
          id='productCode'
          label='Código do produto'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-product-code-test-id',
          }}
          value={pageItemDetails.productCode}
        />
        <S.CustomTextField
          name='productDescription'
          id='productDescription'
          label='Descrição do produto'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-product-description-test-id',
          }}
          value={pageItemDetails.productDescription}
        />
        <S.CustomTextField
          name='minimumExpirationDate'
          id='minimumExpirationDate'
          label='Data de validade mínima'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-minimum-expiration-date-test-id',
          }}
          value={pageItemDetails.minimumExpirationDate}
        />
        <S.CustomTextField
          name='destinationAddress'
          id='destinationAddress'
          label='Endereço de destino'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-destination-address-test-id',
          }}
          value={pageItemDetails.destinationAddress}
        />
        <S.CustomTextField
          name='quantityPerBox'
          id='quantityPerBox'
          label='Qtd. por caixa'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-quantity-per-box-test-id',
          }}
          value={pageItemDetails.quantityPerBox || '-'}
        />
      </S.GridProductInfo>
      <S.GridItemInfo>
        <S.CustomTextField
          name='restockQuantity'
          id='restockQuantity'
          label='Qtd. a repor'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-restock-quantity-test-id',
          }}
          value={pageItemDetails.restockQuantity}
        />
        <S.CustomTextField
          name='originalRestockQuantity'
          id='originalRestockQuantity'
          label='Qtd. a repor original'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-original-restock-quantity-test-id',
          }}
          value={pageItemDetails.originalRestockQuantity || '-'}
        />
        <S.CustomTextField
          name='originalRestockQuantity'
          id='originalRestockQuantity'
          label='Qtd. total coletada'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-total-collected-quantity-test-id',
          }}
          value={pageItemDetails.totalCollectedQuantity}
        />
        <S.CustomTextField
          name='originalRestockQuantity'
          id='originalRestockQuantity'
          label='Qtd. total reposta'
          type='text'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            readOnly: true,
            'data-testid': 'item-total-restocked-quantity-test-id',
          }}
          value={pageItemDetails.totalRestockedQuantity}
        />
      </S.GridItemInfo>
      {pageItemDetails.addressesCollect.length > 0 && (
        <>
          <Typography
            variant='h6'
            sx={{
              marginTop: '.5rem',
              alignSelf: 'center',
              backgroundColor: '#76fd76',
              padding: '0rem 1rem 0rem 1rem',
              borderRadius: '5px 5px 0 0',
            }}
          >{getTitle(PageItemAddressDetailsEnum.COLLECT)}
          </Typography>
          <TableItemAddressesDetails
            type={PageItemAddressDetailsEnum.COLLECT}
            pageItemAddressesDetails={pageItemDetails.addressesCollect}
          />
        </>
      )}
      {pageItemDetails.addressesRestock.length > 0 && (
      <>
        <Typography
          variant='h6'
          sx={{
            marginTop: '1rem',
            alignSelf: 'center',
            backgroundColor: '#fdb376',
            padding: '0rem 1rem 0rem 1rem',
            borderRadius: '5px 5px 0 0',
          }}
        >{getTitle(PageItemAddressDetailsEnum.RESTOCK)}
        </Typography>
        <TableItemAddressesDetails
          type={PageItemAddressDetailsEnum.RESTOCK}
          pageItemAddressesDetails={pageItemDetails.addressesRestock}
        />
      </>
      )}
    </S.CardItem>
  )
}
